export default {
  presets: {
    light: {
      // primary color changed to gray (matching bg-gray-800 / #1F2937)
      primary: '#1F2937',
      backgroundPrimary: '#F4F6F8',
      backgroundSecondary: '#FFFFFF',
      backgroundCardPrimary: '#F7F9F9',
      backgroundCardSecondary: '#ECFDE6',
      success: '#228200',
      info: '#158DE3',
      danger: '#E42222',
      warning: '#FFD43A',
    },
    dark: {
      // ensure primary is set for dark theme too
      primary: '#1F2937',
      backgroundCardPrimary: '#111827',
      backgroundCardSecondary: '#0f172a',
    },
  },
}
